module.exports = __webpack_public_path__ + "img/vpc.42f3055.svg";